import { isEmpty, get, isNil, includes, concat } from 'lodash'
import commonActions from '@/store/data/common/actions'
import { errorHandler } from '@/utils/helpers'
import { webRequestClient } from '@/services'
import helpers from './helpers'

const actions = {
    ...commonActions,

    retrieveItems({ commit, rootState }) {
        //check if behavioral data is active for this user, if not, don't fetch it
        const dataType = get(rootState.data.settings.sociodemo, 'behavioral', null)
        if (!dataType) return

        commit('setIsLoading', true)
        const _route = helpers.buildRoutes(rootState.account)

        return webRequestClient
            .get(_route.taxonomiesRoute, _route.params)
            .then(apiTaxos => {
                if (get(apiTaxos, 'status', '') === 'KO') {
                    throw Error('Error while retrieving behaviorial data')
                } else if (isEmpty(get(apiTaxos, 'list', []))) {
                    throw Error('no third taxo data')
                }
                return apiTaxos
            })
            .then(taxo => {
                return webRequestClient.get(_route.segmentsRoute, _route.params).then(apiSegments => {
                    if (get(apiSegments, 'status', '') === 'KO') {
                        throw Error('Error while retrieving behaviorial data')
                    }
                    if (isEmpty(get(apiSegments, 'list', []))) {
                        throw Error('no segment data')
                    }
                    return [taxo, apiSegments]
                })
            })
            .then(ts => {
                return webRequestClient.get(_route.clusterRoute, _route.clusterParams).then(apiClusters => {
                    if (get(apiClusters, 'status', '') === 'KO') {
                        throw Error('Error while retrieving behaviorial data')
                    }
                    if (isEmpty(get(apiClusters, 'list', []))) {
                        throw Error('no cluster data')
                    }
                    return [...ts, apiClusters]
                })
            })
            .then(response => {
                if (!response) {
                    throw Error('Error while retrieving behaviorial data')
                }
                const countryCode2 = get(rootState, 'account.country.code2', '')
                const taxonomies = response[0].list.map(i => ({ ...i, type: 'Taxonomy' }))
                const segments = response[1].list.map(i => ({ ...i, type: 'Segment' }))
                const clusters = response[2].list.map(i => ({ ...i, type: 'Cluster' }))

                const taxonomiesLegacy = helpers.parseData('taxonomy', response[0].list, countryCode2)
                const segmentsLegacy = helpers.parseData('segment', response[1].list, countryCode2)
                const clustersLegacy = helpers.parseData('cluster', response[2].list, countryCode2)

                commit('setRetrievedItems', { items: concat(taxonomiesLegacy, segmentsLegacy, clustersLegacy) })
                commit('setCollection', helpers.instanciateAll([...taxonomies, ...segments, ...clusters], countryCode2))
            })
            .catch(error => {
                const apiError = get(error, 'apiError', null)
                const errorMessage = get(error, 'message', null)

                if (get(error, 'message', null) === 'no third taxo data') {
                    commit('setRetrievedItems', { items: [] })
                    commit('setCollection', [])
                } else if (!isNil(apiError) || (!isNil(errorMessage) && !includes(errorMessage, 'no data'))) {
                    errorHandler(error, commit)
                }
            })
            .finally(() => {
                commit('setIsLoading', false)
            })
    }
}

export default { ...actions }
